import { Component, HostListener, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, Scroll } from '@angular/router';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import { LoaderService } from '@app/interceptors/loaderInterceptor/loader.service';
import { AuthService } from '@app/services/auth/auth.service';
import { NavbarComponent } from '@app/core/navbar/navbar.component';
import { Messages } from '@app/util/messages.util';
import { RouteStateService } from '@app/services/route-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  msg = Messages
  changeWidthFlag = false;
  defaultWidth = 0;
  RoutingPaths: Array<any>;
  loading = this.loaderService.isLoading;
  routerUrl: boolean = false
  @ViewChild('nav', { static: true }) navbarComponent: NavbarComponent;
  
  // Route state observables from centralized service
  isWorkflowSummaryView$ = this.routeStateService.isWorkflowSummaryView$;
  isWorkflowPrerequisiteView$ = this.routeStateService.isWorkflowPrerequisiteView$;
  isWorkflowExecutionHistoryView$ = this.routeStateService.isWorkflowExecutionHistoryView$;

  // Getter properties for template access
  get isWorkflowSummaryView(): boolean {
    return this.routeStateService.isWorkflowSummaryView;
  }

  get isWorkflowPrerequisiteView(): boolean {
    return this.routeStateService.isWorkflowPrerequisiteView;
  }

  get isWorkflowExecutionHistoryView(): boolean {
    return this.routeStateService.isWorkflowExecutionHistoryView;
  }

  /**
   * constructor
   * @param timestampService
   * @param router
   */
  constructor(private timestampService: CommonFunctionalitiesService,
    private cdRef: ChangeDetectorRef,
    public loaderService: LoaderService,
    public readonly authService: AuthService,
    public readonly router: Router,
    public readonly routeStateService: RouteStateService) {
    this.timestampService.setDefaultTzToMoment();
    this.RoutingPaths = [];
    for (const obj of this.router.config) {
      if (obj.path !== '' && obj.path !== '**') {
        this.RoutingPaths.push(obj.path);
      }
    }
  }

  /**
   * @description ngOnInit() will load on initialization of this page
   * @memberof AppComponent
   */
  ngOnInit() {
    //  if user haven't provided any end point at initial level
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
        this.routerUrl = event.url.includes('/app-auth-callback')
      }

      if (event instanceof Scroll && event.routerEvent.url != '/' && !event.routerEvent.url.includes('/app-auth-callback') && this.navbarComponent) {
        this.navbarComponent.loadNavbar()
      }
    });
  }

  //detect the changes for value change in loader
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: { innerWidth: any; }; }) {
    const width = event.target.innerWidth;
    this.changeWidthFlag = (width <= (this.defaultWidth / 2)) ? true : false;
  }
}
